import { Checkbox, Stack, Typography } from '@mui/material';
import { PeriodPicker } from 'entities/period-picker/period-picker';
import { getCurrentPeriod } from 'entities/period-picker/period.helpers';
import { Period } from 'entities/period-picker/types';
import { useSalaryPeriods } from 'entities/salary/salary-period/salary-period.hook';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ErrorBanner } from 'shared/ui/error-banner';
import { LoadingBanner } from 'shared/ui/loading-banner';

export const PeriodUrlParamsFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { salaryPeriods, isLoading, error } = useSalaryPeriods();
  const [selectedPeriod, setSelectedPeriod] = useState<Period>(getCurrentPeriod());
  const [enabled, setEnabled] = useState<boolean>(false);

  const updatePeriod = (period: Period) => {
    searchParams.set('closingYear', `${period.year}`);
    searchParams.set('closingMonth', `${period.month}`);
    setSelectedPeriod(period);
    setSearchParams(new URLSearchParams(searchParams), { replace: true });
  };
  useEffect(() => {
    if (searchParams.get('closingMonth') && searchParams.get('closingYear')) {
      const month = Number(searchParams.get('closingMonth'));
      const year = Number(searchParams.get('closingYear'));
      setEnabled(true);
      setSelectedPeriod({ month, year });
    }
  }, []);
    
  useEffect(() => {
    if (enabled) {
      searchParams.set('closingMonth', selectedPeriod.month.toString());
      searchParams.set('closingYear', selectedPeriod.year.toString());
      setSearchParams(new URLSearchParams(searchParams), { replace: true });

    } else {
      searchParams.delete('closingMonth');
      searchParams.delete('closingYear');
      setSearchParams(new URLSearchParams(searchParams), { replace: true });


    }
  }, [selectedPeriod, enabled]);

  if (isLoading) {
    return <LoadingBanner />;
  }
  if (error) {
    return <ErrorBanner errorMessage={error} />;
  }
  return (
    <>
      <Stack direction="row" spacing={2} alignItems="center">
        <Checkbox checked={enabled} onChange={(e) => setEnabled(e.currentTarget.checked)}/>
        {!enabled && <Typography>Период закрытия</Typography>}
        {enabled && <PeriodPicker
          size={'small'}
          periods={salaryPeriods}
          selectedPeriod={selectedPeriod}
          onSelect={updatePeriod}
          withManager={false}
          withQueryParams={false}
        />}
      </Stack>
    </>
  );
};
